<template>
  <div class="container competence">
    <div class="row no-gutters competence-header">
      <div class="competence-header__code" v-text="competence.code"></div>
      <div class="competence-header__title" v-text="competence.title"></div>
    </div>

    <app-spinner v-if="loading" />

    <div v-if="competence.docs.length">
      <app-document-list :documents="mainFiles" />

      <div v-if="!loading && appFiles.length"
           class="applications-title">Комплекты оценочной документации</div>
      <app-document-list v-if="!loading && appFiles.length"
                         :documents="appFiles"
                         type="application" />

      <div v-if="!loading && infrastructureFiles.length"
           class="applications-title">
        Требования к инфраструктуре и материально-техническому оснащению мастерских
      </div>
      <app-document-list v-if="!loading && infrastructureFiles.length"
                         :documents="infrastructureFiles"
                         type="application" />
    </div>

    <app-empty-competence v-if="emptyCompetence" />

  </div>
</template>
<script>
import { AppDocumentList, AppSpinner, AppEmptyCompetence } from "@/components";
import { loadCompetence } from "@/api/competencies";

export default {
  name: "Competence",
  components: { AppDocumentList, AppSpinner, AppEmptyCompetence },
  data: () => ({
    competence: {
      docs: []
    },
    loading: true,
    emptyCompetence: false
  }),
  computed: {
    mainFiles() {
      return this.competence.docs.filter(f => f.type === "main");
    },
    appFiles() {
      return this.competence.docs.filter(f => f.type === "application");
    },
    infrastructureFiles() {
      return this.competence.docs.filter(f => f.type === "infra_docs");
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta.breadcrumbs.length === 2) {
      const item = { name: "Разделы", link: from.path };
      to.meta.breadcrumbs.splice(1, 0, item);
    }
    next();
  },
  async created() {
    this.competence = await loadCompetence(this.$route.params);
    this.loading = false;
    this.emptyCompetence = !this.competence.docs.length;
  }
};
</script>
<style lang="scss" scoped>
.loader {
  top: 50%;
}

.competence {
  .competence-header {
    font-size: 30px;
    line-height: 35px;
    font-weight: bold;
  }
  .competence-header__code {
    color: #9c9c9c;
    margin-right: 10px;
  }

  .documents-list {
    padding-top: 40px;
  }
}

.applications-title {
  font-size: 18px;
  font-weight: 500;
  margin: 20px 0;
}
</style>
